import { apiConstants } from './shared/config';

const authAccess = { roles: ['COSI_00582'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home/:code?`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosi" */ './views/Home.vue'),
        meta: {
            auth: authAccess,
            title: 'Home',
        }
    },
];

export default routes;